import React, { useEffect } from 'react';
import Head from 'next/head';
import { Flex, Text } from '@chakra-ui/react';
import { OnlineOrderingUnavailable } from '@olo-web/assets/images/OnlineOrderingUnavailable.ui';
import { useRouter } from 'next/router';
import { useMerchant } from '@domain/merchants/queries/useMerchant';
import { useMerchantPath } from '@domain/merchants/hooks/useMerchantPath';
import { OrderingUnavailableHeader } from './OrderingUnavailableHeader';

export const OnlineOrderingNotConfigured = ({ isDinein }) => {
  const { data: merchant } = useMerchant();
  const router = useRouter();
  const merchantPath = useMerchantPath();

  useEffect(() => {
    if (isDinein && merchant?.orderTypes?.dinein) {
      router.push(`${merchantPath}/dinein`);
    } else if (merchant?.isOrderingAvailable && !isDinein) {
      router.push(merchantPath);
    }
  }, [merchant, router, merchantPath, isDinein]);

  return (
    <Flex w="100vw" h="100vh" pos="relative" align="center" bg="white" flexDirection="column">
      <Head>
        <title>{isDinein ? 'Dine-in Unavailable' : 'Ordering Unavailable'}</title>
      </Head>
      {!isDinein && <OrderingUnavailableHeader />}
      <Flex
        role="main"
        flexDir="column"
        align="center"
        justify={isDinein ? { base: 'center' } : { base: 'flex-start' }}
        w="100vw"
        flex={1}
        px={4}
        background="#F7F7FA"
        borderTop={{ md: '1px solid #E5E7EC', base: 'none' }}
      >
        <OnlineOrderingUnavailable
          h={{ base: '250px', sm: '320px', md: '390px', lg: '480px' }}
          w={{ base: '300px', sm: '400px', md: '500px', lg: '600px' }}
        />
        <Flex flexDir="column">
          <Text
            textStyle="h1"
            fontSize={
              isDinein
                ? { base: '1.8rem', sm: '1.8rem', md: '2rem' }
                : { base: '1.3rem', sm: '1.6rem', md: '2rem' }
            }
            textAlign={{ base: 'center', lg: 'left' }}
          >
            {isDinein ? 'Dine-in unavailable' : 'Online ordering not available.'}
          </Text>
          <Text
            textStyle="subtitle2"
            fontSize={{ base: '0.9rem', sm: '1rem', md: '1.1rem' }}
            textAlign={{ base: 'center', lg: 'left' }}
            fontWeight="normal"
          >
            {`Please try again later${isDinein ? '.' : ' or choose a different location.'}`}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
};
